import { render, staticRenderFns } from "./oldView.vue?vue&type=template&id=2e35e828&"
import script from "./oldView.vue?vue&type=script&lang=js&"
export * from "./oldView.vue?vue&type=script&lang=js&"
import style0 from "./oldView.vue?vue&type=style&index=0&id=2e35e828&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports